import ProfileScreenContainer from '../../features/containers/settings/ProfileScreenContainer';

export default function Profile() {
  return <ProfileScreenContainer />;
}
